export default __webpack_public_path__ + "static/raz-e6818606cb09d6e46859f33ca85484e6.png";